module.exports = __webpack_public_path__ + "img/1751341422728-WhatsApp Image 2025-07-01 at 11.38.08.jpeg.f56b403b.webp";